import cn from 'classnames';
import styles from './ModalContent.module.scss';

export const getClassNames = (className?: string) => {
  return cn(styles.content, className);
};
